// extracted by mini-css-extract-plugin
export default {"cardBlock":"photoItems_cardBlock__0c-0y","cardBody":"photoItems_cardBody__tX0kK","cardTitle":"photoItems_cardTitle__45xXe"};